import PeopleIcon from '@mui/icons-material/People';
import DnsIcon from '@mui/icons-material/Dns';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HandymanIcon from '@mui/icons-material/Handyman';

import * as React from "react"

export const mainNavbarItems = [
    {
        id: 3,
        icon: <DashboardIcon />,
        label: 'Dashboard',
        route: 'dashboard',
    },
    {
        id: 0,
        icon: <DnsIcon />,
        label: 'Assets',
        route: 'assets',
    },
    {
        id: 2,
        icon: <AnalyticsIcon />,
        label: 'LGSR Inspections', 
        route:'inspections'
    },
    {
        id: 4,
        icon: <HandymanIcon />,
        label: 'Contractors',
        route: 'contractors'
    },
    {
        id: 1,
        icon: <PeopleIcon />,
        label: 'User Management',
        route: 'users',
    },

]